export default "__VITE_ASSET__DiuLeJxN__"